import { render } from "./newCustomers.vue?vue&type=template&id=e90d9292"
import script from "./newCustomers.vue?vue&type=script&lang=js"
export * from "./newCustomers.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__